import { requestApi } from '@app/api';
import { withUpload } from '@app/api/paths';

export interface ReservePDFUploadUrlResponse {
  readonly fileId: string;
  readonly otp: string;
  readonly presignedPostUrlResult: PresignedPostUrlResult;
}

interface PresignedPostUrlResult {
  readonly url: string; // 업로드url
  readonly fields: {
    Policy: string;
    'X-Amz-Algorithm': string;
    'X-Amz-Credential': string;
    'X-Amz-Date': string;
    'X-Amz-Security-Token': string;
    'X-Amz-Signature': string;
    bucket: string;
    key: string;
  };
}
export async function reservePDFUploadUrl() {
  return (
    await requestApi<ReservePDFUploadUrlResponse>({
      url: withUpload(`/documents/file-hashes/upload-url`),
      method: 'POST',
      data: {
        extension: 'pdf',
      },
    })
  ).data;
}
